import {useMutation, useQuery} from '@tanstack/react-query';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {apiClient, queryClient} from '@common/http/query-client';
import {showHttpErrorToast} from '@common/http/show-http-error-toast';
import {toast} from '@ui/toast/toast';
import {message} from '@ui/i18n/message';

interface StatusResponse extends BackendResponse {
  deletion_scheduled_at: string | null;
  deletion_initiated_by: 'self' | 'admin' | null;
  grace_days: number;
  scheduled_delete_at: string | null;
}

export function useAccountDeletionStatus() {
  return useQuery({
    queryKey: ['account-deletion-status'],
    queryFn: () =>
      apiClient
        .get<StatusResponse>('account-deletion/status')
        .then(r => r.data),
  });
}

export function useCancelAccountDeletion() {
  return useMutation({
    mutationFn: () =>
      apiClient.post<BackendResponse>('account-deletion/cancel').then(r => r.data),
    onSuccess: async () => {
      toast(message('Account deletion cancelled.'));
      // wipe bootstrap so the page reload re-fetches the authed user
      // (now without deletion_scheduled_at) and CommonRouter drops the gate
      await queryClient.invalidateQueries({
        queryKey: ['account-deletion-status'],
      });
      window.location.assign('/');
    },
    onError: err => showHttpErrorToast(err),
  });
}
